module.exports = __webpack_public_path__ + "img/money_over.06b1b50e.png";